import { GeneralRoutes } from './general.routes';
import { MyAccountRoutes } from './my-account.routes';
import { RouteRecordRaw } from 'vue-router';

export const ClientRoutes: RouteRecordRaw[] = [...GeneralRoutes, MyAccountRoutes];
